import { EMPTY_ARRAY_LENGTH } from '../../../../../../aumico-lib-core-fe/src/lib';

export class HtmlContentMapper {
    public static replaceCKTablesWithTablesForDocxTemplater(content: string): string {
        const newContent: string = this.modifyHtml(content);
        return newContent;
    }

    private static modifyHtml(html: string): string {
        // Create a DOMParser instance
        const parser = new DOMParser();
        // Parse the HTML string
        const doc = parser.parseFromString(html, 'text/html');

        // Find all the colgroup elements
        const colgroups = doc.querySelectorAll('colgroup');

        colgroups.forEach((colgroup) => {
            // Get all the col elements inside the current colgroup
            const cols = colgroup.querySelectorAll('col');
            // Iterate over each col element
            cols.forEach((col, index) => {
                // Get the width style property of the col element
                const width = col.style.width || col.getAttribute('width');
                if (width) {
                    // Find the corresponding td elements in the same table
                    const rows = colgroup.closest('table')?.querySelectorAll('tr');
                    rows?.forEach((row) => {
                        const cells = Array.from(row.cells);
                        let cellIndex = 0;
                        for (const cell of cells) {
                            const colspan = Number.parseInt(cell.getAttribute('colspan') || '1', 10) || 1;
                            if (cellIndex === index) {
                                cell.setAttribute('width', width);
                                break;
                            }
                            cellIndex += colspan;
                        }
                    });
                }
            });
            // Remove the colgroup element
            colgroup.remove();
        });

        // Find all the figure elements
        const figures = doc.querySelectorAll('figure');

        figures.forEach((figure) => {
            const containsTable = !!figure.querySelector('table');
            if (!containsTable) {
                return;
            }
            // Create a new div element
            const div = doc.createElement('div');
            // Copy the classes from the figure to the div
            figure.classList.forEach((className) => {
                div.classList.add(className);
            });
            div.classList.add('richtext-table-in-print');
            // Move the contents of the figure to the div
            while (figure.firstChild) {
                div.appendChild(figure.firstChild);
            }
            // Replace the figure with the div
            figure.parentNode?.replaceChild(div, figure);
        });

        // Ensure empty paragraphs render as blank lines by inserting a <br>
        doc.querySelectorAll('p').forEach((p) => {
            if (p.childNodes.length === 0) {
                p.appendChild(doc.createElement('br'));
            }
        });

        // Wrap tables that are not inside a richtext-table-in-print container (Tiptap output)
        const tables = Array.from(doc.querySelectorAll('table'));
        tables.forEach((table) => {
            const parent = table.parentElement;
            if (parent?.classList.contains('richtext-table-in-print')) {
                return;
            }

            if (parent?.tagName === 'FIGURE') {
                return;
            }

            const wrapper = doc.createElement('div');
            wrapper.classList.add('richtext-table-in-print');
            table.parentNode?.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });

        return doc.body.innerHTML;
    }

    public static extractTables(html: string): string {
        // Create a DOM parser
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Find all table elements
        const tables = doc.querySelectorAll('table');

        // If table element is found, return its outer HTML, otherwise return an empty string
        // Concatenate the outerHTML of each table and return as a single string
        return tables.length !== EMPTY_ARRAY_LENGTH
            ? Array.from(tables)
                .map((table) => table.outerHTML)
                .join('')
            : '';
    }
}
